import React, { Component } from "react";
import { connect } from "react-redux";
import TrinityResultHeader from "./components/TrinityResultHeader";
import TrinityResultExplain from "./components/TrinityResultExplain";
import TrinityResultTable from "./components/TrinityResultTable";
import InfoModal from "../../../components/InfoModal";
import { actions as trinityResultActions } from "../../../redux/modules/trinityResult";
import { actions as trinityActions } from "../../../redux/modules/trinity";
import { requestUserInfo } from "../../../utils/common";
import { get } from "../../../utils/request";
import "./style.css";
class TrinityResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    requestUserInfo();
    this.requestUserTrinityCondition();
    this.requestUserTrinityResult();
    this.fixCss();
    document.title = "浙考之家-每日高升-三一报考大师";
  }
  render() {
    const { uiState, statInfo, wholeSubject, subjectCondition, result } =
      this.props;
    return (
      <div>
        <TrinityResultHeader
          open={this.handleOpen}
          statInfo={statInfo}
          wholeSubject={wholeSubject}
          subjectCondition={subjectCondition}
        ></TrinityResultHeader>
        <div style={{ height: 50 }}></div>
        <TrinityResultExplain></TrinityResultExplain>
        <div
          style={{
            height: this.state.css.height,
          }}
        ></div>
        <TrinityResultTable
          height={this.state.css.tHeight}
          result={result}
        ></TrinityResultTable>
        <InfoModal
          visible={uiState.infoVisible}
          info={uiState.info}
          close={this.handleClose}
        ></InfoModal>
      </div>
    );
  }
  fixCss = () => {
    let width = window.innerWidth;
    if (width <= 330) {
      this.setState({
        css: {
          height: 43,
          tHeight: 66,
        },
      });
    } else if (width >= 400) {
      this.setState({
        css: {
          height: 25,
          tHeight: 55,
        },
      });
    } else {
      this.setState({
        css: {
          height: 43,
          tHeight: 55,
        },
      });
    }
  };
  /**
   * 请求用户的三位一体精灵
   */
  requestUserTrinityCondition = () => {
    let subjectArray = [
      "语文",
      "数学",
      "外语",
      "政治",
      "历史",
      "地理",
      "物理",
      "化学",
      "生物",
      "技术",
    ];
    const { dispatch } = this.props;
    let statInfo = {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      E: 0,
    };
    get("/public/v1/trinity/condition").then((res) => {
      let LevelCondition = JSON.parse(JSON.stringify(res.data.subjectLevels));
      let SubjectCondition = JSON.parse(JSON.stringify(res.data.subjects));
      let PreLevelCondition = JSON.parse(
        JSON.stringify(res.data.subjectLevels)
      );
      let PreSubjectCondition = JSON.parse(JSON.stringify(res.data.subjects));
      for (let i = 0; i < subjectArray.length; i++) {
        if (LevelCondition[subjectArray[i]] !== "") {
          let tmp = statInfo[LevelCondition[subjectArray[i]]];
          statInfo[LevelCondition[subjectArray[i]]] = tmp + 1;
        }
      }
      dispatch(trinityActions.setStatInfo(statInfo));
      dispatch(trinityActions.setStatInfoVisible(true));
      dispatch(trinityActions.setLevelCondition(LevelCondition));
      dispatch(trinityActions.setSubjectCondition(SubjectCondition));
      dispatch(trinityActions.setPreLevelCondition(PreLevelCondition));
      dispatch(trinityActions.setPreSubjectCondition(PreSubjectCondition));
    });
  };
  /**
   * 请求用户三位一体结果集
   */
  requestUserTrinityResult = () => {
    const { dispatch } = this.props;
    get("/public/v1/trinity/result").then((res) => {
      dispatch(trinityResultActions.setResult(res.data));
    });
  };
  /**
   * 打开信息框
   */
  handleOpen = () => {
    const { dispatch } = this.props;
    dispatch(trinityResultActions.setStatInfoVisible(true));
  };
  /**
   * 关闭信息框
   */
  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(trinityResultActions.setStatInfoVisible(false));
  };
}
const mapStateToProps = (state) => {
  //console.log(state.trinityResult.trinityResultData.result);
  return {
    uiState: state.trinityResult.trinityResultUiData,
    statInfo: state.trinity.trinityData.statInfo,
    wholeSubject: state.trinity.trinityData.wholeSubject,
    subjectCondition: state.trinity.trinityData.subjectCondition,
    result: state.trinityResult.trinityResultData.result,
  };
};
export default connect(mapStateToProps)(TrinityResult);



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityResult/index.js